<mat-form-field [appearance]="appearance" style="width: 100%">
  <mat-label>
    <ng-content>{{ label }}</ng-content>
  </mat-label>
  <input matInput type="text" [formControl]="search">
</mat-form-field>
